var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryReporting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.754 15.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-445.999 -573.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.867,15.733A7.867,7.867,0,1,1,13.256,2.139a5.328,5.328,0,0,0-.668-.042,5.268,5.268,0,0,0-1.668.27,6.4,6.4,0,0,0-.693-.332v.323a1.587,1.587,0,0,1-.031.314A5.237,5.237,0,0,0,8.6,3.933H7.867v.787a1.564,1.564,0,0,1-.1.54c-.017.039-.035.081-.053.127a1.582,1.582,0,0,1-1.426.907V8.652H7.508a5.25,5.25,0,0,0,6.875,3.619A7.869,7.869,0,0,1,7.867,15.733ZM1.912,5.845h0a6.276,6.276,0,0,0,5.169,8.262v-1.52L6.294,11.8,4.721,10.226V8.652L3.147,7.079Z",
    transform: "translate(445.999 573.001)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.705 576.282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.606,9.156a4.256,4.256,0,1,0-.75.75l.023.024,2.255,2.255a.532.532,0,0,0,.752-.752L13.63,9.178l-.024-.022ZM12.5,4.292a3.189,3.189,0,1,1-4.51,0,3.189,3.189,0,0,1,4.51,0Z",
    transform: "translate(-5.993 -2.299)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryReporting);
export default __webpack_public_path__ + "static/media/CountryReporting.4ced9450e69d1f936aa4cfc9f2d42b5a.svg";
export { ForwardRef as ReactComponent };